import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'
import { isDateOnly } from 'core/utils/date'

import { type Document } from '../domain/Document'
import { type RawUploadDocumentsResult } from '../infra/ShipperMapper'
import { ShipperRepository } from '../infra/ShipperRepository'

export type UploadDocumentsFactoryDependencies = {
  shipperRepository: ShipperRepository
}

export type UploadShipperDocumentParams = {
  shipperUuid: string
  document: Document
}

export function uploadShipperDocumentFactory({
  shipperRepository,
}: UploadDocumentsFactoryDependencies) {
  return async function (
    params: UploadShipperDocumentParams,
    config?: { signal?: AbortSignal }
  ): Promise<RawUploadDocumentsResult> {
    const { shipperUuid, document } = params
    const { file, type, expirationDate} = document
    const formData = new FormData()
    if (!file) {
      throw new Error('Invalid document file!')
    }
    if (!type) {
      throw new Error('Invalid document type!')
    }
    if (expirationDate) {
      if (!isDateOnly(expirationDate)) {
        throw new Error('Expiration date must be in the format yyyy-MM-dd!')
      }
      formData.append('expiration_date', expirationDate)
    }
    formData.append('attachments', file)
    formData.append('document_type', type)
    return shipperRepository.uploadShipperDocuments(shipperUuid, formData, config)
  }
}

export function uploadShipperDocument(
  params: UploadShipperDocumentParams,
  config?: { signal?: AbortSignal }
): Promise<RawUploadDocumentsResult> {
  const httpClient = new HttpClient(API_URL)
  const shipperRepository = new ShipperRepository({ httpClient })
  const uploadFn = uploadShipperDocumentFactory({ shipperRepository })
  return uploadFn(params, config)
}
